class CommentsList {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.commentsList')

    if (!this.section)
      return

    this.buttons = this.section.querySelectorAll('.commentsList__itemButton')

    return true

  }

  setEvents() {

    this.buttons.each((item) => {

      item.addEventListener('click', (e) => {
      
        e.preventDefault()
        this.saveVote(e.currentTarget)
      
      })

    })

  }

  saveVote(button) {

    const isLike  = button.hasClass('commentsList__itemButton--up')
    const wrapper = button.parentNode

    wrapper.addClass('commentsList__itemButtons--disabled')
    button.addClass('commentsList__itemButton--active')
    button.innerHTML = parseInt(button.innerHTML) + 1

  }

}